module.exports = __webpack_public_path__ + "img/Redcarnation.0a5d2a74.png";